module.exports = __webpack_public_path__ + "img/date-time.c0965e1d.svg";